/* eslint-disable id-length */
import { completeTypes, createTypes, withPostSuccess } from 'redux-recompose';

import * as AdelphiSpiritReductionsService from '#services/AdelphiSpiritReductionsService';
import ModalActions from '#redux/Modal/actions';
import { MODALS } from '#redux/Modal/constants';

import { ADELPHI_SPIRIT_REDUCTIONS_TARGETS } from './constants';

export const actions = createTypes(
  completeTypes({
    primaryActions: [
      'CREATE_ADELPHI_SPIRIT_REDUCTION',
      'GET_ALL_ADELPHI_SPIRIT_REDUCTIONS',
      'UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID',
      'GET_ADELPHI_SPIRIT_REDUCTION_BY_ID'
    ],
    ignoredActions: ['SET_CURRENT_ADELPHI_SPIRIT_REDUCTION']
  }),
  '@@ADELPHI_SPIRIT_REDUCTIONS'
);

export const actionCreators = {
  setCurrentSpiritReduction: payload => ({
    type: actions.SET_CURRENT_ADELPHI_SPIRIT_REDUCTION,
    target: ADELPHI_SPIRIT_REDUCTIONS_TARGETS.CURRENT_ADELPHI_SPIRIT_REDUCTION,
    payload
  }),
  createSpiritReduction: values => ({
    type: actions.CREATE_ADELPHI_SPIRIT_REDUCTION,
    target: ADELPHI_SPIRIT_REDUCTIONS_TARGETS.CREATE_ADELPHI_SPIRIT_REDUCTION,
    payload: values,
    service: AdelphiSpiritReductionsService.createAdelphiSpiritReduction,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllSpiritReductionsAndCloseModal());
      })
    ]
  }),
  getAllSpiritReductions: () => ({
    type: actions.GET_ALL_ADELPHI_SPIRIT_REDUCTIONS,
    target: ADELPHI_SPIRIT_REDUCTIONS_TARGETS.ADELPHI_SPIRIT_REDUCTIONS,
    service: AdelphiSpiritReductionsService.getAllAdelphiSpiritReductions
  }),
  getSpiritReductionById: id => ({
    type: actions.GET_ADELPHI_SPIRIT_REDUCTION_BY_ID,
    payload: id,
    target: ADELPHI_SPIRIT_REDUCTIONS_TARGETS.ADELPHI_SPIRIT_REDUCTION_BY_ID,
    service: AdelphiSpiritReductionsService.getAdelphiSpiritReductionById,
    successSelector: response => response.data.spiritReduction
  }),
  updateSpiritReductionById: ({ id, values }) => ({
    type: actions.UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID,
    target: ADELPHI_SPIRIT_REDUCTIONS_TARGETS.UPDATE_ADELPHI_SPIRIT_REDUCTION_BY_ID,
    payload: { id, values },
    service: AdelphiSpiritReductionsService.updateAdelphiSpiritReductionById,
    injections: [
      withPostSuccess(dispatch => {
        dispatch(actionCreators.getAllSpiritReductionsAndCloseModal());
      })
    ]
  }),
  getAllSpiritReductionsAndCloseModal: () => dispatch => {
    dispatch(actionCreators.getAllSpiritReductions());
    dispatch(actionCreators.setCurrentSpiritReduction(null));
    dispatch(ModalActions.closeModal(MODALS.ADELPHI_SPIRIT_REDUCTION));
  }
};

export default actionCreators;
